import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';

import { AUTH_PROVIDER } from './auth.provider';
import { AuthProviderType } from './auth.constants';
import { IAuthProvider } from './auth-provider.interface';

import { EntraAuthProvider } from './providers/entra-auth.provider';
import { KeycloakAuthProvider } from './providers/keycloak-auth.provider';

export function authProviderFactory(): IAuthProvider {

    switch (environment.auth.provider) {

        case AuthProviderType.Keycloak:
            return inject(KeycloakAuthProvider);

        case AuthProviderType.Entra:
        default:
            return inject(EntraAuthProvider);

    }

}